<template>
  <div class="apply-list">
    <h2 class="apply-list__title">
      {{ title }}
    </h2>
    <div class="apply-list__back">
      <b-button variant="primary" class="btn-icon" @click="handleBack">
        <feather-icon icon="ArrowLeftIcon" />
      </b-button>
    </div>

    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :option="option"
      :page="page"
      :loading="loading"
      :permission="permissionList"
      :before-open="beforeOpen"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
      @submit-add="submitAdd"
      @submit-edit="submitEdit"
    >
      <!-- 自定义列 -->
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'assigneeName'">
          <b-button
            v-if="
              props.row.assigneeName &&
                props.row.assigneeName.split(',').length > 2
            "
            v-b-popover.hover.right="props.row.assigneeName"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            title="Approver"
            variant="flat-primary"
          >
            {{ props.row.assigneeName.split(',')[0] }}...
          </b-button>
          <span v-else-if="props.row.assigneeName">
            {{ props.row.assigneeName }}
          </span>
        </span>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip
          v-if="row.STATUS !== 1"
          :tooltip="$t('_components.btns.view')"
        >
          <feather-icon
            icon="SearchIcon"
            class="text-warning cursor-pointer mr-1"
            size="20"
            @click="handleStepChange('viewPage', row)"
          />
        </my-tooltip>
        <my-tooltip
          v-if="row.status === 1"
          :tooltip="$t('_components.btns.edit')"
        >
          <feather-icon
            icon="Edit2Icon"
            class="text-warning cursor-pointer mr-1"
            size="20"
            @click="handleStepChange('edit', row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.cancel')">
          <feather-icon
            v-if="row.status === 5"
            icon="XIcon"
            class="text-danger cursor-pointer"
            size="20"
            @click="cancelProcess(row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.send')">
          <feather-icon
            v-if="getStatusOption(row.status).send"
            icon="SendIcon"
            class="text-success cursor-pointer"
            size="20"
            @click="handleStepChange('send', row)"
          />
        </my-tooltip>
      </template>
    </gtable-crud>

    <c-modal
      :visible="modalShow"
      :title="modalTitle"
      size="lg"
      @close="modalShow = false"
      @modelConfirm="handleModelConfirm"
    >
      <template slot="content">
        <my-form
          v-if="getFormOption(stepMethodKey)"
          ref="overFormRef"
          :data="rowData"
          :loading="modalFormLoading"
          :option="getFormOption(stepMethodKey)"
          :footer-visible="false"
          width="auto"
        />
        <span v-else>
          {{ $t(`_staff.prompt.base.${stepMethodKey}Message`) }}
        </span>
      </template>
    </c-modal>

    <!-- 提交面试结果或者View页面 -->
    <c-drawer v-model="drawerShow" :before-close="handleBeforeClose">
      <component
        :is="stepMethodKey"
        v-if="drawerShow"
        v-bind="componentParams"
        @close="handleDrawerClose"
      />
    </c-drawer>
  </div>
</template>

<script>
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import CModal from '@/components/crud/modal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import MyForm from '@/components/myForm/index.vue'
import { BButton, BFormRadio, VBPopover } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CDrawer from '@/components/drawer.vue'
import MyTooltip from '@/components/myTooltip.vue'
import { mapGetters } from 'vuex'
import add from '@/views/apply/components/add.vue'
import edit from '@/views/apply/components/edit.vue'
import viewPage from '@/views/apply/components/viewPage.vue'
import components from '@/config/processOption'
import { templateFormat } from '@/util/func'

export default {
  components: {
    ...components,
    CModal,
    MyForm,
    BButton,
    add,
    edit,
    viewPage,
    CDrawer,
    MyTooltip,
    BFormRadio,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      data: [],
      loading: false,
      componentParams: {},
      title: '',
      drawerTitle: '',
      modalShow: false,
      drawerShow: false,
      formSelectShow: false,
      processId: '',
      formId: '',
      processKey: '',
      processInstanceId: '',
      stepMethodKey: '',
      rowData: {},
      modalTitle: '',
      modalFormLoading: false,
      auditLoading: false,
      formList: [],
      viewAll: false,
    }
  },
  created() {
    // const {
    //   title, processKey, formId, viewAll,
    // } = this.$route.query
    // this.formId = formId
    // this.viewAll = viewAll === 'true'
    // this.title = title
    // this.formList = [
    //   {
    //     formName: title,
    //     id: formId,
    //     processKey,
    //   },
    // ]
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.menu_add,
        viewBtn: this.permission.menu_view,
        delBtn: this.permission.menu_del,
        editBtn: this.permission.menu_edit,
      }
    },
    statusOption() {
      // 0已发出面试邀请 2未参加面试 4等待面试 6未通过面试
      // 8通过面试,等待反馈 10已拒绝 14已确认,等待审批 16审批中
      // 18审批失败 20审批通过 22已发出offer 24拒绝offer 26接受offer
      const option = {
        1: {
          color: 'bg-gradient-secondary',
          send: true,
        },
        5: {
          color: 'bg-gradient-warning',
        },
        7: {
          color: 'bg-gradient-danger',
        },
        9: {
          color: 'bg-gradient-success',
        },
      }
      const defaultDictArr = this.$store.getters.dicts.dictBiz
      const findDict = defaultDictArr.find(
        (o) => o.code === 'interview_ process_status'
      )
      if (findDict) {
        findDict.children.forEach((item) => {
          if (option[item.dictKey]) {
            option[item.dictKey].label = item.dictValue
          }
        })
      }
      return option
    },
    option() {
      return {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: (row) => row.STATUS === 1, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: [
          {
            label: this.i18n('formId'),
            field: 'formId',
            dictField: 'formName',
            type: 'select',
            dictCode: 'staffTemplateForm',
            search: true,
            searchBase: true,
          },
          {
            label: this.i18n('createUser'),
            field: 'createUserName',
          },
          {
            label: this.i18n('applicationTime'),
            field: 'createTime',
            type: 'dateRange',
          },
          {
            label: this.i18n('lastApprovalTime'),
            field: 'lastApprovalTime',
          },
          {
            label: this.i18n('assigneeName'),
            field: 'assigneeName',
            slot: true,
          },
          {
            label: this.i18n('taskName'),
            field: 'taskName',
          },
          {
            label: this.i18n('status'),
            field: 'status',
            type: 'select',
            dictBizCode: 'process_status',
            dictField: 'statusName',
            search: true,
            searchBase: true,
          },
        ],
      }
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      let res = {}
      res = await applyAPI.getMyList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      )

      const { data } = res.data
      this.page.total = data.total
      const temp = data.records
      const result = []
      data.records.forEach((item) => {
        item.createTime = this.formatTableDate(item.createTime)
        const p = item

        p.approvalTime = this.formatTableDate(item.bladeFlow.createTime)
        p.taskName = item.bladeFlow.taskName
        p.lastApprovalTime = this.formatTableDate(
          item.bladeFlow.lastApprovalTime
        )
        if (item.bladeFlow.assigneeName) {
          p.assigneeName = item.bladeFlow.assigneeName.replace(/,/g, ' , ')
        }
        result.push(p)
      })
      this.data = result
      this.loading = false
    },
    formatTableDate(e) {
      if (e) {
        return moment(e).format('YYYY-MM-DD HH:mm')
      } else {
        return ''
      }
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
    },
    findData(key) {
      let res = {}
      if (this.processInstanceId) {
        res =
          this.data.find(
            (o) => o.processInstanceId === this.processInstanceId
          ) || {}
      } else {
        res = this.data.find((o) => o.id === this.rowData.id) || {}
      }
      return res[key]
    },
    cancelProcess(row) {
      this.$bvModal
        .msgBoxConfirm(this.i18n('cancelProcessTip'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true
            applyAPI
              .cancelProcess({ processInstanceId: row.processInstanceId })
              .then((res) => {
                this.loading = false
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              })
          }
          this.loading = false
        })
    },
    // i18n
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      const temp = e
      if (temp.createTime) {
        ;[temp.startTime, temp.endTime] = temp.createTime
        delete temp.createTime
      }
      this.query = temp
      this.page.currentPage = 1
      await this.onLoad(this.page, temp)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    // 点击下载按钮
    rowDel(e) {
      applyAPI
        .remove(e.id)
        .then(() => {
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.danger'),
              variant: 'danger',
            },
          })
        })
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    beforeOpen(done, type) {
      const formatDic = {
        add: 'Add',
        edit: 'Edit',
        view: 'View',
        upload: 'Upload',
      }
      this.drawerTitle = formatDic[type]
      done()
    },
    submitAdd(done, form) {
      const params = form
      applyAPI
        .add(params)
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: this.$t('system.user.tip.success'), // "操作成功!"
          })
          done()
        })
        .catch(() => {
          done()
        })
    },
    submitEdit(done, form) {
      applyAPI
        .update(form)
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: this.$t('system.user.tip.success'), // "操作成功!"
          })
          done()
        })
        .catch(() => {
          done()
        })
    },
    handleBeforeClose(done) {
      done()
      this.onLoad(this.page)
    },
    handleDrawerClose() {
      this.drawerShow = false
      this.onLoad(this.page)
    },
    handleBack() {
      this.$router.go(-1) // 返回上一层
    },
    getFormOption(key) {
      return this[`${key}Option`] || false
    },
    handleStepChange(key, row) {
      this.processId = row.id
      this.formId = row.formId
      this.processKey = row.processKey
      if (['add'].indexOf(key) !== -1) {
        this.drawerShow = true
      } else if (['edit'].indexOf(key) !== -1) {
        const parmas = { processId: this.processId, formId: row.formId }
        this.componentParams = parmas
        this.drawerShow = true
      } else if (['viewPage'].indexOf(key) !== -1) {
        if (!row.bladeFlow || row.bladeFlow === {}) {
          this.drawerShow = true
        }
        if (key === 'viewPage' && row.bladeFlow) {
          let variables = row.bladeFlow.variables || {}
          let option = variables.option || null
          if (!option) {
            option = row.configuration || '{}'
            this.loading = true
            applyAPI.detail({ id: row.id }).then((res) => {
              this.loading = false
              const { data } = res.data
              variables = data.map || {}
              const parseOption = JSON.parse(option)
              this.stepMethodKey = parseOption.component || 'viewPage'
              const parmasArr = parseOption.params || []
              const parmas = { processId: this.processId }
              parmasArr.forEach((item) => {
                parmas[item.key] = this[item.value] || variables[item.value]
              })
              this.componentParams = parmas
              this.drawerShow = true
            })
          } else {
            const parseOption = JSON.parse(option)
            this.stepMethodKey = parseOption.component || 'viewPage'
            const parmasArr = parseOption.params || []
            const parmas = { processId: this.processId }
            parmasArr.forEach((item) => {
              parmas[item.key] = this[item.value] || variables[item.value]
            })
            this.componentParams = parmas
            this.drawerShow = true
          }
        } else {
          this.stepMethodKey = key
        }
      } else {
        this.modalShow = true
        this.modalTitle = this.$t(`_staff.prompt.base.${key}Title`)
      }

      this.rowData = row || {}
    },
    // handleFormSelectConfirm() {
    //   this.drawerShow = true
    //   this.formSelectShow = false
    // },
    async handleModelConfirm() {
      this.modalFormLoading = true
      const key = this.stepMethodKey
      if (key === 'send') {
        applyAPI.start({ processId: this.rowData.id }).then((res) => {
          this.modalFormLoading = false
          this.modalShow = false
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      }
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
  },
}
</script>
<style lang="scss">
.apply-list {
  position: relative;
  .dropdown-menu {
    min-width: 13rem;
  }
  &__title {
    position: absolute;
    left: 50%;
    top: -50px;
    transform: translateX(-50%);
  }
  &__back {
    position: absolute;
    top: -50px;
    right: 0;
  }
}
.audit-container {
  text-align: center;
}
</style>
